import React, { useEffect, useState } from 'react'
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom';
import { getEvents } from '../Service/Api';
const s3_url = "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com"
function HomeEvents() {
    const [eventsData, setEventsData] = useState([])

    useEffect(() => {
        async function getEventsData() {
            try {
                let event_api_data = await getEvents(); // ✅ await here
                setEventsData(event_api_data);          // ✅ set state properly
            } catch (error) {
                console.error(error)
            }
        }

        getEventsData(); // ✅ CALL the function
    }, [])

    console.log("what is eventsData", eventsData)

    const formatDate = (dateValue) => {
        if (!dateValue) return "";
        const parsed = new Date(dateValue);
        if (Number.isNaN(parsed.getTime())) return dateValue;
        return parsed.toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        });
    };

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        cssEase: "linear",
        responsive: [
            { breakpoint: 1599, settings: { slidesToShow: 3 } },
            { breakpoint: 1199, settings: { slidesToShow: 2 } },
            { breakpoint: 991, settings: { slidesToShow: 2 } },
            { breakpoint: 600, settings: { slidesToShow: 1 } },
            { breakpoint: 480, settings: { slidesToShow: 1 } }
        ]
    };

    return (
        <div className='row'>
            <div className='EventSec arrownone'>
                <Slider {...settings}>
                    {eventsData.map((item, index) => {  // ✅ use state here
                        const imagePath = Array.isArray(item?.images) ? item.images[0] : "";
                        const imageUrl = imagePath
                            ? `${s3_url}/${imagePath}`
                            : `${s3_url}/SMNSB/public/images/events.jpg`;

                        return (
                            <div className="slide-padding" key={item?._id || index}>
                                <div className='EventBox'>
                                    <img src={imageUrl} className="img-fluid" alt={item?.title || "event"} />
                                    <h4>{item?.title || "Event"}</h4>
                                    <p>{item?.description || ""}</p>
                                    <h5>
                                        <i className="bi bi-geo-alt-fill"></i>
                                        {item?.venue || "School Campus"}
                                    </h5>
                                    <h6 className="date-time">
                                        <span className="time-block">
                                            <i className="bi bi-clock"></i> {item?.time || ""}
                                        </span>
                                        <span className="date-block">
                                            {formatDate(item?.date)}
                                        </span>
                                    </h6>
                                </div>
                            </div>
                        );
                    })}
                </Slider>
            </div>
        </div>
    )
}

export default HomeEvents;